import React from "react";
import { Modal, InputNumber } from "antd";
import * as Style from "../../../newComponents/styledComponents/styles/ModalStyle";

export const AddMonthlyExtra = ({
  formData,
  handleChange,
  handleSubmit,
  closeModal,
  showModal,
}) => {
  return (
    <Modal footer={null} closable={false} visible={showModal} centered>
      <Style.HeaderConatiner>
        <Style.ModalTitle>Recurring funding for extra payment</Style.ModalTitle>
      </Style.HeaderConatiner>
      <div>
        <div style={{ marginTop: "8px" }}>
          <Style.FieldsTitle>
            Extra<span style={{ color: "red" }}>*</span>
          </Style.FieldsTitle>

          <div className="inputWrapper" style={{ display: "flex" }}>
            <span
              style={{
                fontSize: "15px",
                padding: "8px",
                display: "flex",
                alignItems: "center",
                color: "rgba(0, 0, 0, 0.65)",
                background: "#fafafa",
                borderRadius: "4px",
                border: "1px solid #d1d5db",
              }}
            >
              $
            </span>
            <InputNumber
              step={1}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              className="Input"
              placeholder="Extra"
              name="amount"
              value={formData && formData.Extra}
              id="amount"
              onChange={(value) => {
                handleChange("Extra", value);
              }}
            />
          </div>
        </div>
      </div>
      <Style.WrapperButtons>
        <Style.CancelButton
          onClick={() => {
            closeModal();
          }}
        >
          Cancel
        </Style.CancelButton>
        <Style.SaveButton
          onClick={handleSubmit}
          disabled={!formData || formData.Extra === null || formData.Extra === undefined}
        >
          Save
        </Style.SaveButton>
      </Style.WrapperButtons>
    </Modal>
  );
};
